import axios from 'axios'
import { baseUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
// 查询用户信息列表
export function getUser(params) {
  const url = baseUrl + '/user/roles/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '查询用户信息列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询角色列表
export function getRoles(params) {
  const url = baseUrl + '/role/list'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '查询角色列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询组织树
export function getOus(params) {
  const url = baseUrl + '/orgunit/tree'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '查询组织树', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询组织列表
export function getOuList(params) {
  const url = baseUrl + '/orgunit/findList'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '查询组织列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 保存用户
export function saveUser(params) {
  const url = baseUrl + '/user/save'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '保存用户', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除用户
export function delUser(params) {
  const url = baseUrl + '/user/softdelete/' + params.id
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '删除用户', res)
    }
    return Promise.resolve(res.data)
  })
}

// 编辑用户
export function editUser(params) {
  const url = baseUrl + '/user/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '编辑用户', res)
    }
    return Promise.resolve(res.data)
  })
}

// 重置密码
export function resetPassword(params) {
  const url = baseUrl + '/user/password/reset'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '重置密码', res)
    }
    return Promise.resolve(res.data)
  })
}

// 新增组织架构
export function saveOrgunit(params) {
  const url = baseUrl + '/orgunit/save'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '新增组织架构', res)
    }
    return Promise.resolve(res.data)
  })
}

// 软删除组织架构，包含子节点
export function deleteOrgunit(params) {
  const url = baseUrl + '/orgunit/softdelete/' + params.id
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '删除组织架构', res)
    }
    return Promise.resolve(res.data)
  })
}

// 更新组织架构
export function editOrgunit(params) {
  const url = baseUrl + '/orgunit/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('用户管理', '更新组织架构', res)
    }
    return Promise.resolve(res.data)
  })
}

// 导出模板
export function exportExcel() {
  const url = baseUrl + '/user/export'
  return axios({
    method: 'get',
    url: url,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('用户管理', '下载模板', { status: res.status, data: { state: -1, msg: '下载模板失败' } })
    }
    return Promise.resolve(res.data)
  })
}

// 批量导入用户
export function importExcel(params) {
  const url = baseUrl + '/user/import'
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('用户管理', '批量导入用户', { status: res.status, data: { state: -1, msg: '批量导入用户失败' } })
    }
    return Promise.resolve(res.data)
  })
}
